import * as yup from 'yup'

import { EMAIL_FIELD } from '@/constants/forms/forgotPassword'

export default yup.object().shape({
    [EMAIL_FIELD]: yup.string().email('Invalid email address').required('Please enter your email')
})
